import './util/queryStringParser'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AsyncComputed from 'vue-async-computed'
import { loadEnv } from './util/env'
import lang, { setLang } from './lang'

// this somehow affects material ui icons
import 'vue-material-design-icons/styles.css'

Vue.config.productionTip = false

Vue.use(AsyncComputed)

const log = (...args) => console.log(...args)

const branch = window.APP_BRANCH || '<no branch>'
const version = window.APP_VERSION || '<no version>'

import { get, post } from './util/ajax'

window.api = { get, post }

log(`App version ${branch} / ${version}`)

async function start() {
	setLang()

	await loadEnv()

	new Vue({
		router,
		store,
		render: h => h(App),
		el: '.App'
	})
}

// Without this the user is left staring at an empty page when startup fails
function showStartupError() {
	const appElement = document.querySelector('.App')
	if (!appElement) return

	const message = (lang.error && lang.error.somethingWrongTryAgain) || 'Something went wrong. Try again.'
	const errorElement = document.createElement('p')
	errorElement.textContent = message
	errorElement.setAttribute('style', 'color: white; padding: 40px; text-align: center;')
	appElement.appendChild(errorElement)
}

start().catch(error => {
	console.error('could not start app', error)
	showStartupError()
})
